import { render, staticRenderFns } from "./TrainersActivityPreview.vue?vue&type=template&id=163afb9a&scoped=true"
import script from "./TrainersActivityPreview.vue?vue&type=script&lang=js"
export * from "./TrainersActivityPreview.vue?vue&type=script&lang=js"
import style0 from "./TrainersActivityPreview.vue?vue&type=style&index=0&id=163afb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163afb9a",
  null
  
)

export default component.exports